<div class="d-flex justify-content-center pt-3 pb-3">
    <output class="spinner-border spinner-border-sm text-secondary" style="width: 3rem; height: 3rem">
        <span class="sr-only">Loading...</span>
    </output>
</div>
